import { Node } from './node';

export abstract class Branch extends Node {
    public static _type: string = 'Branch';
    public nodes: Node[] = [];
    public branches: Branch[] = [];

    public canDelete: boolean = false;

    public get model(): any {
        const { canDelete, nodes, branches, ...rest } = super.model;
        return rest;
    }

    public constructor(source?: any) {
        super(source);

        if (source) {
            this.canDelete = source.canDelete;
        }
    }

    public override copy(source?: any): void {
        super.copy(source);

        if (source) {
            this.canDelete = source.canDelete;
        }
    }
}
